import { StyledFlex, StyledGridCol, StyledGridRow } from "@/common/styles";
import { StyledUserFormGroup } from "./styles";
import { useDispatch, useSelector } from "react-redux";

const UsersBasicInfoSection = () => {
  const dispatch = useDispatch();
  const { bookings } = useSelector((s) => s?.bookings);

  return (
    <>
      <StyledUserFormGroup>
        <StyledGridRow justify="start" marginTop="10px" gutter={16}>
          <StyledGridCol lg={12} xl={12}>
            <StyledFlex gap="10px">
              <div className="key">Last Name</div>
              <div className="value dark-btn form-value-box">
                {bookings?.bio?.[0]?.lName}
              </div>
            </StyledFlex>
          </StyledGridCol>
          <StyledGridCol lg={12} xl={12}>
            <StyledFlex marginBottom="10px" gap="10px">
              <div className="key">First Name</div>
              <div className="value dark-btn form-value-box">
                {bookings?.bio?.[0]?.fName}
              </div>
            </StyledFlex>
          </StyledGridCol>
          <StyledGridCol lg={12} xl={8}>
            <StyledFlex marginBottom="10px" gap="10px">
              <div className="key">Rank</div>
              <div className="value dark-btn form-value-box">
                {bookings?.rankHr?.[0]?.rank}
              </div>
            </StyledFlex>
          </StyledGridCol>
          <StyledGridCol lg={10} xl={8}>
            <StyledFlex gap="10px">
              <div className="key">Badge Number</div>
              <div className="value dark-btn form-value-box">
                {bookings?.badge}
              </div>
            </StyledFlex>
          </StyledGridCol>

          <StyledGridCol lg={10} xl={8}>
            <StyledFlex gap="10px">
              <div className="key">Agency</div>
              <div className="value dark-btn form-value-box">
                {bookings?.organization?.[0]?.agency ?? ""}
              </div>
            </StyledFlex>
          </StyledGridCol>

          {/* <StyledGridCol lg={12} xl={8}>
            <FormItem
              label="Active Staff Member?"
              layout="horizontal"
              labelPostion="label-right"
              className="dark-form-item checkbox-control"
              //   name="isActive"
              valuePropName="checked"
            >
              <Checkbox
                checked={bookings?.isActive}
                onChange={changeIsActive}
              />
            </FormItem>
          </StyledGridCol> */}
        </StyledGridRow>

        <StyledGridRow
          justify="start"
          marginTop="10px"
          gutter={16}
          // gutter={16}
          // marginTop="15px"
          // justify="end"
          style={{ width: "100%" }}
        >
          <StyledGridCol lg={12} xl={6}>
            <StyledFlex gap="10px">
              <div className="key">Active</div>
              <div
                className={`value form-value-box ${
                  bookings?.isActive ? "green" : "red"
                }`}
              >
                {bookings?.isActive ? "Yes" : "No"}
              </div>
            </StyledFlex>
          </StyledGridCol>
          <StyledGridCol lg={12} xl={6}>
            <StyledFlex gap="10px">
              <div className="key">Can Login</div>
              <div
                className={`value form-value-box ${
                  bookings?.isPoliceCentralUser ? "green" : "red"
                }`}
              >
                {bookings?.isPoliceCentralUser ? "Yes" : "No"}
              </div>
            </StyledFlex>
          </StyledGridCol>
        </StyledGridRow>
      </StyledUserFormGroup>
    </>
  );
};
export default UsersBasicInfoSection;
